@let hasShiftCreatePermission =
  can(RoleAction.Create, RolePermissionSubject.Shift);

<div class="d-flex">
  @if (
    {
      isQuickShiftDraggable:
        createNewViaDragAndDropService.isQuickShiftDraggable$ | async,
    };
    as data
  ) {
    <div
      class="shift-card d-flex align-items-center text-truncate"
      nz-tooltip
      [nzTooltipTitle]="
        !hasShiftCreatePermission
          ? ('general.forbidden_action' | translate)
          : null
      "
      [class.hide-card]="!isQuickCreationCardOpen"
      [class.not-allowed]="
        !hasShiftCreatePermission || !data.isQuickShiftDraggable
      "
      [draggable]="hasShiftCreatePermission && data.isQuickShiftDraggable"
      (dragstart)="startDrag($event)"
      (dragend)="dragEnd()"
      data-test-id="wilson-new-shift-quick-creation-card"
    >
      <div class="d-block">
        <p class="mb-2 fw-normal text-dark card-text">
          {{ 'page.shift_timeline.empty_shift' | translate }}
        </p>
        <div class="activity-card"></div>
      </div>
    </div>
  }
</div>
